define('modules/editor/models/elements/base',['require','exports','module','backbone','lib/util','../../behaviours/has_property_groups','../../behaviours/has_geometry'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      util = require("lib/util");

  var Serialization = {
    toJSON: function() {
      return _.extend(
        module.exports.__super__.toJSON.call(this),
        { name: this.name },
        { properties: _.invoke(this.propertyGroups, "toJSON") }
      );
    }
  };

  module.exports = Backbone.Model.extend({
    defaults: {
      displayOrder: 0
    },
    constructor: function(attributes, options) {
      this.initPropertyGroupsWithDefaults();
      module.exports.__super__.constructor.call(this, attributes, _.omit(options, "silenceNotify"));
      //property groups are already initialized here
      if(attributes && attributes.x && attributes.y){
        //set position when dragging into section
        this.setPosition(_.pick(attributes, "x", "y"));
        delete attributes.x;
        delete attributes.y;
      }

      // set every property group sent through ctor/init
      var silenceNotify = options && _.pick(options, "silenceNotify");
      this.setPropertyGroups(_.result(attributes, 'properties'), silenceNotify);
    },
    defaultPropertyGroups: [
      { name: "geometry",
        defaults: { width: 200, height: 200, top: 10, left: 10 }
      }
    ],
    geometryProperty: "geometry",
    /**
     * Deep clones an element with its property groups
     * @param  {Model} original Original element model
     * @return {Model}          Copied element
     */
    selfClone: function() {
      if (!this.collection) return;
      var newElement = this.clone();
      //copy property groups
      _.each(this.propertyGroups, function(pg){
        var newPg = newElement.getPropertyGroup(pg.name);
        newPg.set(pg.attributes);
      });
      newElement.getPropertyGroup("idclass").set("id", "");
      return newElement;
    },
    getElementById: function(id) {
      var myId = this.getPropertyGroup("idclass").get("id");
      return (myId === id) && this;
    },
    toJSON: Serialization.toJSON
  }, {
    fromJSON: Serialization.fromJSON
  });

  util.mixin(module.exports, require("../../behaviours/has_property_groups"));
  util.mixin(module.exports, require("../../behaviours/has_geometry"));

});

